// Knowledge section: Insights/Webinars tabs fetch the latest 3 posts from
// the WP REST API and render cards, cached per tab.

const CLOCK_SVG =
  '<svg class="kn-card__clock" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
  '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>' +
  '<path d="M12 7.5V12l3 1.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

// Matches klik_get_reading_time() (ceil, 200wpm).
function readingTime(html) {
  const text = (html || '').replace(/<[^>]+>/g, ' ');
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 200));
}

// Safely turn a REST `*.rendered` HTML string into plain text.
function decodeText(html) {
  const t = document.createElement('textarea');
  t.innerHTML = (html || '').replace(/<[^>]+>/g, '');
  return t.value;
}

function pickCategory(post) {
  const terms = post._embedded && post._embedded['wp:term'];
  if (!terms) return '';
  for (const group of terms) {
    if (group && group.length && group[0].name) return group[0].name;
  }
  return '';
}

function featuredUrl(post) {
  const media = post._embedded && post._embedded['wp:featuredmedia'];
  if (media && media[0] && media[0].source_url) return media[0].source_url;
  return '';
}

function cardMarkup(post) {
  const img = featuredUrl(post);
  const cat = pickCategory(post);
  const minutes = readingTime(post.content && post.content.rendered);
  const title = decodeText(post.title && post.title.rendered);
  const link = post.link || '#';

  const imgPart = img
    ? '<div class="kn-card__img"><img src="' + img + '" alt="" loading="lazy" ' +
      'onerror="this.closest(\'.kn-card__img\').classList.add(\'kn-card__img--empty\');this.remove();"></div>'
    : '<div class="kn-card__img kn-card__img--empty"></div>';
  const catPart = cat ? '<span class="kn-card__cat">' + cat + '</span>' : '';

  return (
    '<a class="kn-card" href="' + link + '">' +
    imgPart +
    '<div class="kn-card__meta">' + catPart +
    '<span class="kn-card__time">' + CLOCK_SVG + minutes + ' min to read</span></div>' +
    '<h3 class="kn-card__title">' + title + '</h3>' +
    '</a>'
  );
}

export default function initKnowledge() {
  const section = document.querySelector('.section-knowledge');
  if (!section) return;

  const grid = section.querySelector('.section-knowledge__grid');
  const tabs = Array.from(section.querySelectorAll('.section-knowledge__tab'));
  if (!grid || !tabs.length) return;

  const cache = {};
  let current = null;

  function render(rest) {
    if (cache[rest] !== undefined) {
      grid.innerHTML = cache[rest];
      return;
    }
    grid.classList.add('is-loading');
    fetch('/wp-json/wp/v2/' + rest + '?per_page=3&_embed')
      .then((r) => r.json())
      .then((posts) => {
        if (!Array.isArray(posts)) throw new Error('Unexpected REST response');
        const html = posts.length
          ? posts.map(cardMarkup).join('')
          : '<p class="section-knowledge__empty">Nothing to show yet.</p>';
        cache[rest] = html;
        grid.innerHTML = html;
      })
      .catch(() => {
        grid.innerHTML = '<p class="section-knowledge__empty">Couldn’t load posts right now.</p>';
      })
      .finally(() => grid.classList.remove('is-loading'));
  }

  function activate(tab) {
    const rest = tab.dataset.rest;
    if (rest === current) return;
    current = rest;
    tabs.forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    render(rest);
  }

  tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab)));

  // Default to the active tab (Insights → posts).
  activate(tabs.find((t) => t.classList.contains('is-active')) || tabs[0]);
}
